module.exports = __webpack_public_path__ + "static/media/diya (2).5136814a.jpg";